module.exports = __webpack_public_path__ + "static/media/clock.e3b1e57a.svg";